import EL from '../../../../EL/EL.js';
import SVGANIMATION from '../../../../DOM/svg/SVGOBJECT/SVGANIMATION.js';
import { SVGANIMATIONELEMENT } from '../../../../../enums/SVGANIMATIONELEMENT.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
;
// Model Structure
export const svgAnimateTransformAttr = makeAttrStruct([
    ['attributeName'],
    ['begin'],
    ['dur'],
    ['type'],
    ['repeatCount'],
    ['from'],
    ['to'],
    ['keyTimes']
]);
export const svgAnimateTransformData = makeDataStruct([]);
export const svgAnimateTransformModel = makeStruct([
    ['attributes', svgAnimateTransformAttr],
    ['data', svgAnimateTransformData]
]);
// Simplified Model
export function svgAnimateTransform(attributeName, begin, dur, type, repeatCount, from, to, keyTimes) {
    return {
        attributes: svgAnimateTransformAttr(attributeName, begin, dur, type, repeatCount, from, to, keyTimes),
        data: svgAnimateTransformData()
    };
}
/** Creates an animation object for an SVG Shape */
export default class SVGANIMATETRANSFORM extends SVGANIMATION {
    // public declare el: SVGAnimateTransformElement;
    constructor(node, model) {
        super(node, SVGANIMATIONELEMENT.ANIMATETRANSFORM, model);
    }
}
export { EL };
